import React from 'react';

export const RedFlex = () => {
    return(
      <>
         <div className='unefonFlex'></div>
        <div className="txtRedes1">Todos los paquetes mostrados incluyen: Llamadas/SMS ilimitados* y Redes sociales ilimitadas**</div>
     </>  
    )
    
}
